// Formattazione del prezzo di una scheda, condivisa da card, dettaglio e dashboard.
const euro = (v) => {
  const n = Number(v);
  if (n === 0) return 'Gratis';
  const decimali = Number.isInteger(n) ? 0 : 2;
  return `€${n.toLocaleString('it-IT', { minimumFractionDigits: decimali, maximumFractionDigits: 2 })}`;
};

// Range [prezzo_min, prezzo_max] con fallback al prezzo legacy; senza prezzi → "su richiesta".
export function formatPrezzo(servizio) {
  const { prezzo_min: min, prezzo_max: max, prezzo } = servizio;
  if (min == null && max == null) {
    return prezzo != null ? euro(prezzo) : 'Prezzo su richiesta';
  }
  if (min != null && max != null) {
    if (Number(min) === Number(max)) return euro(min);
    return Number(min) === 0 ? `fino a ${euro(max)}` : `${euro(min)} - ${euro(max)}`;
  }
  return min != null ? `da ${euro(min)}` : `fino a ${euro(max)}`;
}
